import React from 'react'
import { useMatch, useNavigate } from 'react-router'
import { useBetAccount } from '@mobi/account/Hooks'
import { routes as verificationAccountRoutes } from '../Utils/routes'
import { routes as signupRoutes } from '../../SignUp/Utils'

export const useIsVerificationAccount = (enabled: boolean) => {
  const navigate = useNavigate()

  const {
    data: betAccount,
    isPending: isBetAccountLoading,
    isError: isBetAccountError,
  } = useBetAccount({ enabled })

  const isVerificationAccount = betAccount?.IdVerificationOnlyInd?.toUpperCase() === 'Y'
  const isSignupPage = useMatch(signupRoutes.any)

  React.useEffect(() => {
    if (!enabled) return
    if ((isVerificationAccount || isBetAccountError) && !isSignupPage) {
      navigate(verificationAccountRoutes.VerificationAccountHome)
    }
  }, [enabled, isVerificationAccount, isBetAccountError, isSignupPage, navigate])

  return {
    betAccount,
    isBetAccountLoading,
    isBetAccountError,
    isVerificationAccount,
  }
}
